module.exports = __webpack_public_path__ + "2cbc28bb98956230f93928ccae228e30.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/mozilla.svg
// module id = 412
// module chunks = 0